import React, { useState } from "react";
import SearchBar from "../components/searchbar";
import Add from '@material-ui/icons/Add';
import {MdOutlineVideoCall} from 'react-icons/md';
import { ButtonModal, ColumnRight, ContainerSearchBar, TitleSearch } from "../components/searchbar/styles";
import CategoriesTable from "./CategoriesTable";


const PublisherCategories = () => {

  const [searchedString, setSearchedString] = useState('');

  const onChangeHandler = (e) => {
    setSearchedString(e.target.value);
}

  return (
            <>
              <ContainerSearchBar>
              <TitleSearch>
              Categorias
              </TitleSearch>
              <ColumnRight>
              <SearchBar customPlaceholder='Buscar categoria'
                        onChangeHandler={onChangeHandler}
                        searchedString={searchedString}
                        setSearchedString={setSearchedString}/>
              <ButtonModal>
                <Add  style={{color:"#FF4C00", paddingRight:"5px"}}size={25}/>
              Adicionar
              </ButtonModal>
              </ColumnRight>
              </ContainerSearchBar>
              <CategoriesTable/>
              </>
)}
export default PublisherCategories;
